import type { HomeCardsConfig } from '../../components/home-cards.tsx';

const SERVICE_DESK = '/it/service-desk';
const PANEL = '/it/dashboard';
const DEVICES = '/it/devices';

/** Cartões da Visão geral: TI (ADR 0097). */
export const IT_CARDS: HomeCardsConfig = {
  queryKey: 'it',
  endpoint: '/it/home-cards',
  consultTo: '/it/pending',
  cards: [
    {
      id: 'tickets',
      section: 'deadline',
      title: 'it.homeCards.tickets.title',
      criterion: 'it.homeCards.tickets.criterion',
      link: { to: SERVICE_DESK, search: { sla: 'in' } },
      outsideLink: { to: SERVICE_DESK, search: { sla: 'out' } },
      noneLink: { to: SERVICE_DESK, search: { sla: 'none' } },
    },
    {
      id: 'renewals',
      upcoming: true,
      section: 'deadline',
      title: 'it.homeCards.renewals.title',
      criterion: 'it.homeCards.renewals.criterion',
      unit: 'it.homeCards.renewals.unit',
      link: { to: PANEL, search: { alert: 'renewals' } },
    },
    {
      id: 'notices',
      upcoming: true,
      section: 'deadline',
      title: 'it.homeCards.notices.title',
      criterion: 'it.homeCards.notices.criterion',
      unit: 'it.homeCards.notices.unit',
      link: { to: PANEL, search: { alert: 'notices' } },
    },
    {
      id: 'returns_overdue',
      section: 'deadline',
      title: 'it.homeCards.returnsOverdue.title',
      criterion: 'it.homeCards.returnsOverdue.criterion',
      unit: 'it.homeCards.returnsOverdue.unit',
      link: { to: DEVICES, search: { flag: 'return_overdue' } },
    },
    {
      id: 'offboardings',
      section: 'pending',
      title: 'it.homeCards.offboardings.title',
      criterion: 'it.homeCards.offboardings.criterion',
      unit: 'it.homeCards.offboardings.unit',
      link: { to: '/it/offboardings', search: { status: 'open' } },
    },
    {
      id: 'licenses_inactive',
      section: 'pending',
      title: 'it.homeCards.licensesInactive.title',
      criterion: 'it.homeCards.licensesInactive.criterion',
      unit: 'it.homeCards.licensesInactive.unit',
      link: { to: PANEL, search: { alert: 'inactiveHolders' } },
    },
    {
      id: 'licenses_retired',
      section: 'pending',
      title: 'it.homeCards.licensesRetired.title',
      criterion: 'it.homeCards.licensesRetired.criterion',
      unit: 'it.homeCards.licensesRetired.unit',
      link: { to: '/it/devices/dashboard', search: { list: 'retired_licenses' } },
    },
    {
      id: 'terms_pending',
      section: 'pending',
      title: 'it.homeCards.termsPending.title',
      criterion: 'it.homeCards.termsPending.criterion',
      unit: 'it.homeCards.termsPending.unit',
      link: { to: DEVICES, search: { flag: 'term_pending' } },
    },
  ],
};
